import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2l-2 0","key":"svg-0"}],["path",{"d":"M14 8h-2m-2 2v6h4","key":"svg-1"}],["path",{"d":"M10 12h2","key":"svg-2"}],["path",{"d":"M17 8v5m3 3h1","key":"svg-3"}],["path",{"d":"M3 3l18 18","key":"svg-4"}]]

const IconHttpDeleteOff = createReactComponent('outline', 'http-delete-off', 'HttpDeleteOff', __iconNode);

export default IconHttpDeleteOff;